import type { SerializedInventoryLocationBuilding } from '@enmon/commons/lib/tools';
import type {
  LocationBootstrapBuilding,
  LocationBootstrapLocation,
} from '@/features/location-bootstrap/location-bootstrap-types';

export {
  deriveManufacturers,
  readMeterModels,
} from '@/features/location-bootstrap/location-bootstrap-meter-model-mapper';

export function readLocationBootstrapData(location: LocationBootstrapLocation) {
  return {
    buildings: location.inventory_location_buildings
      .map(readInventoryBuilding)
      .filter((building): building is LocationBootstrapBuilding => Boolean(building)),
    location,
  };
}

function readInventoryBuilding(building: SerializedInventoryLocationBuilding): LocationBootstrapBuilding | null {
  if (!building.name) {
    return null;
  }

  return {
    code: building.code,
    id: building.id,
    name: building.name,
    raw: building,
  };
}
